import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  TablePagination,
  Link,
  Box,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import { toast } from "react-toastify";
import ViewIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import EditIcon from "@material-ui/icons/Edit";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../css/employee-page.css";
import { useNotification } from "../../../hooks/useNotification.js";
import NoDataFound from "../../../components/NoDataFound/index.js";

export default function ApplyPermission() {
  const classes = useStyles();

  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [viewPermissionData, setViewPermissionData] = useState([]);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    startTime: Yup.string().required("Start Time is required").nullable(),
    duration: Yup.string().required("Duration is required"),
    reason: Yup.string().required("Permission Reason is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      startTime: null,
      duration: "1hour",
      endTime: null,
      reason: "",
    },
  });

  // Watch for changes
  const startTime = watch("startTime");
  const duration = watch("duration");

  useEffect(() => {
    if (startTime && duration) {
      let endTime = moment(startTime);
      if (duration === "1hour") {
        endTime = endTime.add(1, "hour");
      } else if (duration === "2hour") {
        endTime = endTime.add(2, "hour");
      }
      setValue("endTime", endTime.toDate());
    }
  }, [startTime, duration, setValue]);

  useEffect(() => {
    fetchPermissionsData();
  }, []);

  const fetchPermissionsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}permission/viewMyPermissions`,
        data: {
          page: currerntPage,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setViewPermissionData(response.data.data);
          console.log(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}permission/viewMyPermissions`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setViewPermissionData(response.data.data);
        setCount(response.data.count);
      }
      setLoader(false);
    });
  };

  async function handleAdd(values) {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}permission/addPermissionRequest`,
        {
          fromTime: moment(values.startTime).format("YYYY-MM-DD HH:mm"),
          toTime: moment(values.endTime).format("YYYY-MM-DD HH:mm"),
          reason: values.reason,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleFeedbackModalClose();
        fetchPermissionsData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      handleNotificationCall("error", error.response.data.message);
      console.error(error);
    }
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="My Permissions" />
        </Grid>
        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={handleFeedbackModalOpen}
            >
              Apply Permission
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              color="primary"
              onClick={handleFeedbackModalOpen}
            >
              Add
            </Button>
          </div>
        </Grid>
      </Grid>
      {viewPermissionData.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}
      <Grid container spacing={2}>
        {viewPermissionData.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item}>
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  <b>Permission Date:</b>{" "}
                  {moment(item.createdAt).format("MMM Do YYYY")}
                  <br />
                  <br />
                  <b>Permission Timing:</b>{" "}
                  {moment(item.fromTime).format("LT") +
                    " - " +
                    moment(item.toTime).format("LT")}
                </Typography>

                <Typography
                  variant="body2"
                  component="p"
                  style={{ marginTop: "10px" }}
                >
                  {item.reason}
                </Typography>
              </CardContent>
              <CardActions
                style={{ padding: "0px 16px 16px", justifyContent: "flex-end" }}
              >
                <Typography color="textSecondary">
                  {moment(item.createdAt).format("MMM Do YYYY")}
                </Typography>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        open={feedbackModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={handleFeedbackModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", margin: 0 }}>Apply Permission</h3>
          {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={6}>
                <Grid container direction="row" spacing={2}>
                  {/* Date Picker */}
                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="startTime">
                      Select Time
                    </InputLabel>
                    <Controller
                      name="startTime"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          className="date-time-input"
                          wrapperClassName="date-time-input-wrapper"
                          {...field}
                          selected={field.value}
                          onChange={(date) => field.onChange(date)}
                          showTimeSelect
                          dateFormat="Pp"
                        />
                      )}
                    />
                    {errors.startTime && (
                      <p style={{ color: "red", marginTop: "8px" }}>
                        {errors.startTime.message}
                      </p>
                    )}
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="duration">
                      Duration
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="duration"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)} // Register value changes
                            error={!!errors.duration} // Error handling
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            <MenuItem value="1hour">1 Hour</MenuItem>
                            <MenuItem value="2hour">2 Hours</MenuItem>
                          </Select>
                        )}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.duration?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="reason">
                      Permission Reason
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        multiline
                        minRows={5}
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter your Feedback Message..."
                        name="reason"
                        {...register("reason")}
                        error={errors.reason ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.reason?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <Grid></Grid>
                <Grid style={{ padding: "24px" }}>Your Permission Time</Grid>

                {startTime && duration && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    style={{ padding: "0px 24px" }}
                  >
                    <Typography variant="body2">Selected Time: </Typography>
                    <Typography variant="body2">
                      {`${moment(startTime).format("hh:mm A")} - ${moment(
                        watch("endTime"),
                      ).format("hh:mm A")}`}
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleFeedbackModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
